// Actions
const ACTION_TYPES = {
  RESET_ALL: "web-app-magmic-core/user/RESET_ALL",
  SET_LOAD_COMPLETE: "web-app-magmic-core/user/SET_LOAD_COMPLETE",
  SET_DATA_REFRESH_REQUESTED_DATE: "web-app-magmic-core/user/SET_DATA_REFRESH_REQUESTED_DATE",
  SET_USER: "web-app-magmic-core/user/SET_USER",
  SET_BRAINCLOUD_SESSION: "web-app-magmic-core/user/SET_BRAINCLOUD_SESSION",
  SET_FORTE_DATA: "web-app-magmic-core/user/SET_FORTE_DATA",
  SET_MAGMIC_COIN: "web-app-magmic-core/user/SET_MAGMIC_COIN",
  SET_USER_TRANSACTION_PET_IDS: "web-app-magmic-core/user/SET_USER_TRANSACTION_PET_IDS",
  SET_USER_TRANSACTIONS_BY_PET_ID: "web-app-magmic-core/user/SET_USER_TRANSACTIONS_BY_PET_ID",
  SET_USER_PETS: "web-app-magmic-core/user/SET_USER_PETS"
}

export const resetAll = () => ({
  type: ACTION_TYPES.RESET_ALL
});

export const setLoadComplete = () => ({
  type: ACTION_TYPES.SET_LOAD_COMPLETE
});

export const setDataRefreshRequestedDate = (dataRefreshRequestedDate) => ({
  type: ACTION_TYPES.SET_DATA_REFRESH_REQUESTED_DATE,
  dataRefreshRequestedDate: dataRefreshRequestedDate
});

export const setUser = (userData) => ({
  type: ACTION_TYPES.SET_USER,
  user: userData
});

export const setBraincloudSession = (braincloudSession) => ({
  type: ACTION_TYPES.SET_BRAINCLOUD_SESSION,
  braincloudSession: braincloudSession // {sessionId:string, bcId:string}
});

export const setForteData = (forteData) => ({
  type: ACTION_TYPES.SET_FORTE_DATA,
  forteData: forteData // {id:string, gameId:string, email:null, createAt:dateString }
});

export const setMagmicCoin = (magmicCoin) => ({
  type: ACTION_TYPES.SET_MAGMIC_COIN,
  magmicCoin: magmicCoin
});

export const setUserTransactionPetIds = (userTransactionPetIds) => ({
  type: ACTION_TYPES.SET_USER_TRANSACTION_PET_IDS,
  userTransactionPetIds: userTransactionPetIds
});

export const setUserTransactionsByPetId = (userTransactionsByPetId) => ({
  type: ACTION_TYPES.SET_USER_TRANSACTIONS_BY_PET_ID,
  userTransactionsByPetId: userTransactionsByPetId
});

export const setUserPets = (userPets) => ({
  type: ACTION_TYPES.SET_USER_PETS,
  userPets: userPets
});

const initialState = {
  dataRefreshRequestedDate: undefined,
  loadComplete: false,
  user: {}, // an empty object more safely allows for a component's useEffect to watch for object property changes
  braincloudSession: {},
  forteData: {},
  magmicCoin: undefined,
  userTransactionPetIds: [],
  userTransactionsByPetId: {},
  userPets: []
};

// Reducers
export default (state = initialState, action = {}) => {
  switch (action.type) {
    case ACTION_TYPES.RESET_ALL:
      //return initialState; <-- overkill
      return {
        ...state,
        loadComplete: false
      };
    case ACTION_TYPES.SET_LOAD_COMPLETE:
      return {
        ...state,
        loadComplete: true
      };
    case ACTION_TYPES.SET_DATA_REFRESH_REQUESTED_DATE:
      return {
        ...state,
        dataRefreshRequestedDate: action.dataRefreshRequestedDate
      };
    case ACTION_TYPES.SET_USER:
      return {
        ...state,
        user: action.user
      };
    case ACTION_TYPES.SET_BRAINCLOUD_SESSION:
      return {
        ...state,
        braincloudSession: action.braincloudSession
      };
    case ACTION_TYPES.SET_FORTE_DATA:
      return {
        ...state,
        forteData: action.forteData
      };
    case ACTION_TYPES.SET_MAGMIC_COIN:
      return {
        ...state,
        magmicCoin: action.magmicCoin
      };
    case ACTION_TYPES.SET_USER_TRANSACTION_PET_IDS:
      return {
        ...state,
        userTransactionPetIds: action.userTransactionPetIds
      };
    case ACTION_TYPES.SET_USER_TRANSACTIONS_BY_PET_ID:
      return {
        ...state,
        userTransactionsByPetId: action.userTransactionsByPetId
      };
    case ACTION_TYPES.SET_USER_PETS:
      return {
        ...state,
        userPets: action.userPets
      };
    default:
      return state; // returned during app initialization
  }
}
